import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

type LoadingProps = {
  loading: boolean;
};

const useStyles = makeStyles({
  container: {
    position: "relative",
  },
  loading: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.2)",
  },
});

const Loading = ({loading}: LoadingProps) => {
  const classes = useStyles();
  return (
    <>
      {loading && (
        <div className={classes.container}>
          <div className={classes.loading}>
            <CircularProgress size={120} />
          </div>
        </div>
      )}
    </>
  );
};

export default Loading;
